exports = module.exports = require("../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "", ""]);
